import React from 'react'

type DropDownProps = {
  values: string[]
  onValueChange: (event: React.ChangeEvent<HTMLSelectElement>) => void
  value: string
}

const DropDown = ({
  values, onValueChange, value
}: DropDownProps) => {
  return (
    <>
      <span>
        <select className='cuttingTool-dropDown' name='cuttingTool-dropDown' onChange={onValueChange} autoComplete='off' value={value}>
          {
            values.map((value: string, i: number) => <option key={i} value={value}>{value}</option>)
          }
        </select>
      </span>
    </>
  )
}

export default DropDown
